import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const FilterIcon20 = (props: SvgProps) => (
  <Svg
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <Path
      fill="#fff"
      d="M5.625 4.375v8.75-8.75Zm0 8.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM10 6.875v8.75-8.75Zm0-2.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm4.375 6.875v4.375-4.375Zm0-2.5V4.375 8.75Zm0 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
    />
    <Path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.625 4.375v8.75M10 6.875v8.75m4.375-4.375v4.375m0-6.875V4.375m-8.75 8.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM10 4.375a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm4.375 4.375a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
    />
  </Svg>
);
export default FilterIcon20;
